// API Service for ZenIO Panel
// Replace YOUR-API-ID with your actual API Gateway ID after deployment

const API_BASE_URL = 'https://ssso0a02dk.execute-api.us-west-1.amazonaws.com/prod';

// For development/testing, you can temporarily use this:
// const API_BASE_URL = 'http://localhost:3001/api';

export const api = {
  // ========== Authentication ==========
  
  async login(username, password) {
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password })
      });
      
      if (!response.ok) {
        throw new Error('Login failed');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  // ========== User Management ==========
  
  async getUsers() {
    try {
      const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch users');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get users error:', error);
      throw error;
    }
  },

  async createUser(userData) {
    try {
      const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to create user');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Create user error:', error);
      throw error;
    }
  },

  async updateUser(userId, userData) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to update user');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update user error:', error);
      throw error;
    }
  },

  async deleteUser(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${userId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete user');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Delete user error:', error);
      throw error;
    }
  },

  // ========== Site Management ==========
  
  async getSites() {
    try {
      const response = await fetch(`${API_BASE_URL}/sites`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to fetch sites');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Get sites error:', error);
      throw error;
    }
  },

  async createSite(siteData) {
    try {
      const response = await fetch(`${API_BASE_URL}/sites`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(siteData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to create site');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Create site error:', error);
      throw error;
    }
  },

  async updateSite(siteId, siteData) {
    try {
      const response = await fetch(`${API_BASE_URL}/sites/${siteId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(siteData)
      });
      
      if (!response.ok) {
        throw new Error('Failed to update site');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Update site error:', error);
      throw error;
    }
  },

  async deleteSite(siteId) {
    try {
      const response = await fetch(`${API_BASE_URL}/sites/${siteId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete site');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Delete site error:', error);
      throw error;
    }
  }
};

// Helper function to check if API is configured
export const isAPIConfigured = () => {
  return !API_BASE_URL.includes('YOUR-API-ID');
};

// Helper function to use localStorage as fallback
export const useLocalStorageFallback = () => {
  return !isAPIConfigured();
};
